import { html as t, when as o, repeat as s } from "@microsoft/fast-element";
const l = (p) => {
  const a = t.partial(p.prefix);
  return t`
    <div class="control" part="control">
      ${o(
    (e) => e.pageSizeOptions && e.pageSizeOptions.length > 0,
    t`
          <div class="rows" part="rows">
          <span class="rows-per-page" part="rows-per-page">
            ${(e) => e.tpi18n.rowsPerPage}:
          </span>
            <${a}-listbox
              ?disabled="${(e) => e.disabled}"
              @change="${(e, i) => e.handlePageSizeChange(i)}"
            >
              ${s(
      (e) => e.pageSizeOptions,
      t`
                  <${a}-listbox-option
                    value="${(e) => e}"
                    ?selected="${(e, i) => e == i.parent.pageSize}"
                  >${(e) => e}
                  </${a}-listbox-option>
                `
    )}
            </${a}-listbox>
          </div>
        `
  )}
      <${a}-pagination
        total="${(e) => e.total}"
        page="${(e) => e.page}"
        ?disabled="${(e) => e.disabled}"
      ></${a}-pagination>
    </div>
  `;
};
export {
  l as tablePaginationTemplate
};
